import { useAppSelector } from '../redux';
import { userSelectors } from '../redux/user';
import { SIGN_UP_PROVIDERS } from '../constants';

/**
 * Custom hook to determine if email verification should be skipped
 * Returns true if user signed up with Google OAuth (email is already verified by Google)
 */
export const useSkipEmailVerification = (): boolean => {
  const userData = useAppSelector(userSelectors.getUserData);

  return userData?.signupProvider === SIGN_UP_PROVIDERS.GOOGLE;
};
